/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMemoryStoresUpdateEntry } from "../../funcs/llmMemoryStoresUpdateEntry.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateMemoryEntryRequest$inboundSchema,
};

export const tool$llmMemoryStoresUpdateEntry: ToolDefinition<typeof args> = {
  name: "llm-memory-stores-update-entry",
  description: `Update memory entry`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMemoryStoresUpdateEntry(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
